<template>
    <BaseModal :show="show" v-on:close="onClose">
        <div class="paper"></div>
    </BaseModal>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    name: 'UnsavedChangesModal',
    mixins: [clickaway],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onKey(event) {
            if (event.key === 'Escape') {
                this.onClose();
            }
        },
        onClose() {
            this.$interfaces.unsavedChanges.toggleOpen();
        },
    },
    watch: {
        show(shouldShow, wasShowing) {
            if (shouldShow) {
                document.addEventListener('keyup', this.onKey);
            } else {
                document.removeEventListener('keyup', this.onKey);
            }
        },
    },
};
</script>

<style scoped>
.paper {
    display: block;
    margin: 0 auto;

    width: 100%;
    max-width: 640px;

    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.93);

    padding: 40px 60px;
}

@media only screen and (max-width: 600px) {
    .paper {
        padding: 18px 24px;
        min-height: 100vh;
        width: 100vw;
        border-radius: 0;
    }
}
</style>
